/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl, resolveUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useMutation } from '@tanstack/react-query';
import config from 'config';

/**
 * Remove project.
 */

function uploadImage(client: AxiosInstance, file: File): Promise<string> {
  const formData = new FormData();
  formData.append('file', file);

  return client.post(resolveAppUrl('uploadImage'), formData).then(({ data }) => {
    console.log('##############################', data.url);

    return resolveUrl(config?.api?.baseUrl, data.url);
  });
}

/**
 * Export `useUploadImage`.
 */

export function useUploadImage() {
  const client = useRequestProvider();

  return useMutation({
    mutationFn: async (file: File) => {
      const result = await uploadImage(client, file);

      return result;
    }
  });
}
